import React from 'react';

interface DragDropWrapperProps {
  children: React.ReactNode;
}

// Simplified wrapper - drag & drop between folders will be handled via 
// a move-to-folder action in the note editor instead of drag & drop
// This provides a more reliable mobile experience
const DragDropWrapper: React.FC<DragDropWrapperProps> = ({ children }) => {
  return <>{children}</>;
};

export default DragDropWrapper;
